import { attr, hasMany } from '@ember-data/model';
import { buildValidations, validator } from 'ember-cp-validations';
// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { or } from '@ember/object/computed';
import Super, { BIRTH_DATE_VALIDATOR } from './base-client';

const Validations = buildValidations({
  firstName: validator('presence', {
    presence: true,
    ignoreBlank: true,
    messageKey: 'errors.blankField',
  }),
  lastName: validator('presence', {
    presence: true,
    ignoreBlank: true,
    messageKey: 'errors.blankField',
  }),
  emails: validator('has-many'),
  phones: validator('has-many'),
  birthDate: BIRTH_DATE_VALIDATOR,
  state: validator('presence', {
    presence: true,
    messageKey: 'errors.clientContact.stateRequired',
    disabled: or('model.skipContactFormSpecificValidations', 'model.skipPrescreenerValidation'),
  }),
});

export default class ClientContact extends Super.extend(Validations) {
  skipContactFormSpecificValidations = true;

  @hasMany('email', { async: false, inverse: null }) emails;
  @hasMany('phone', { async: false, inverse: null }) phones;
  @attr() firstName;
  @attr() lastName;
}
